const ASSET_SIGNAL_CSV = 'tracker-asset-signal-csv';
const CREATE_ALERT_EVENT = 'tracker-create-alert';
const CREATE_SCHEDULE_EVENT = 'tracker-create-schedule';
const ERROR_LOGIN_FORM = 'tracker-error-login-form';
const EXIT_ORG_EVENT = 'tracker-exit-org';
const EXPORT_ASSETS_EVENT = 'tracker-export-assets';
const EXPORT_DM1_CSV_DATA = 'tracker-export-dm1-csv-data';
const SUBSCRIPTION_ASSET_ALERTS = 'tracker-subscription-asset-alerts';
const SUBSCRIPTION_ASSET_DM1S = 'tracker-subscription-asset-dm1s';
const TAG_CREATE_EVENT = 'tracker-create-tag';

export {
  ASSET_SIGNAL_CSV,
  CREATE_ALERT_EVENT,
  CREATE_SCHEDULE_EVENT,
  ERROR_LOGIN_FORM,
  EXIT_ORG_EVENT,
  EXPORT_ASSETS_EVENT,
  EXPORT_DM1_CSV_DATA,
  SUBSCRIPTION_ASSET_ALERTS,
  SUBSCRIPTION_ASSET_DM1S,
  TAG_CREATE_EVENT,
};
